module.exports = __webpack_public_path__ + "static/media/icon-modal-arrow-right-light.721d765c.svg";